import React, { FC } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useLocalAnalyticsState } from "../../../graphql/hooks";
import { formatDateRange } from "../../../common/AnalyticsHelpers";
import styles from "./DailyBadges.module.scss";
import { parse } from "path";

interface Props {
    gameplay?: number;
    endScreen?: number;
    impressions?: number;
}

const UserQueryCTRImplementation: FC<Props> = ({
    gameplay,
    endScreen,
    impressions
}) => {
    const { analyticsEnabled } = useLocalAnalyticsState();
    const savedDateRange = localStorage.getItem("user-query-date-range");
    const parsedDateRange = savedDateRange
        ? JSON.parse(savedDateRange)
        : undefined;

    if (
        !analyticsEnabled ||
        (!gameplay && !endScreen) ||
        !impressions ||
        impressions <= 0 ||
        !savedDateRange ||
        parsedDateRange.length === 0
    ) {
        return null;
    }

    const formattedDateRange = parsedDateRange
        ? formatDateRange(parsedDateRange[0], parsedDateRange[1])
        : "N/A";

    const ctr = (
        (((gameplay || 0) + (endScreen || 0)) / impressions) *
        100
    ).toFixed(1);

    return (
        <>
            <div className={`${styles.analyticsText} text-inverse`}>
                <OverlayTrigger
                    placement="top"
                    delay={{ show: 200, hide: 100 }}
                    overlay={
                        <Tooltip id="user-badge-tooltip-ctr">
                            {`CTR - ${formattedDateRange}`}
                        </Tooltip>
                    }
                >
                    <span style={{ whiteSpace: "nowrap" }}>
                        {parseFloat(ctr).toLocaleString()}{" "}
                        <span className="text-inverse">%</span>
                    </span>
                </OverlayTrigger>
            </div>
        </>
    );
};

export const UserQueryCTR = React.memo(UserQueryCTRImplementation);
